import { VisitType } from './../reference-data';
import {Tests} from "../tests/tests";
export class ProjectManagement{

    id: number;
    projectId: string;
    clientId: number;
    clientName: string;
    projectName: string;
    projectDesc: string;
    projectStartDate: Date;
    projectEndDate: Date;
    displayMemberTypes: string;
    displayVisitTypes: string;
    memberTypes: number[];
    screeningTypes: number[];
    visitTypes: string[];
    refVisitTypes: VisitType[];
    additionalExams: number[];
    maxCallLimit: number;
    assignedBatches: number[];
    updatedTimestamp: string;
    createdTimestamp: string;
    createdBy: string;
    updatedBy: string;
    isActive:boolean;

}

export class GetAllClientsNames{

    clientId: number;
    clientName: string;

}

export class CreateProjectRequest{

    assessmentType: string;
    clientId: number;
    createdBy: string;
    maxCallLimit: number;
    projectDesc: string;
    projectEndDate: string;
    projectName: string;
    projectStartDate: string;
    visitDuration: number;
    visitTypes: any[];
    tests: Tests;

}

export class UpdateProjectRequest{

    assessmentType: string;
    clientId: number;
    maxCallLimit: number;
    projectDesc: string;
    projectEndDate: string;
    projectId: number;
    projectName: string;
    projectStartDate: string;
    updatedBy: string;
    visitDuration: number;
    visitTypes: any[];
    tests: Tests;

}
